import type { ReactNode } from 'react'
import { XendrelLogo } from '@/components/brand/XendrelLogo'

/** Frame shared by the public auth pages: a centred column with the logo on top. */
export function AuthPageShell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-dvh bg-background flex flex-col items-center justify-center px-4 py-8 md:py-0">
      <XendrelLogo className="h-10 mb-8 text-foreground" />
      {children}
    </div>
  )
}
